import { ChangeDetectionStrategy, Component, ElementRef, HostListener, OnInit } from '@angular/core'
import { Router } from '@angular/router'

import { User } from '../../../domain/user'
import { AuthService } from '../../../services/auth.service'
import { CartService } from '../../../services/cart.service'
import { CoreEnvironmentService } from '../../../services/core-environment.service'
import { ProducerService } from '../../../services/producer.service'
import { Nullable } from '../../../types/utils.type'

@Component({
  selector: 'bmcore-account-menu',
  templateUrl: './bmcore-account-menu.component.html',
  styleUrls: ['./bmcore-account-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreAccountMenuComponent implements OnInit {
  user: User
  isMenuOpen = false
  adminAccountUrl: string

  newAvatar: Nullable<string> = null

  constructor(
    private authService: AuthService,
    private router: Router,
    private eRef: ElementRef,
    private cartService: CartService,
    private coreEnvironmentService: CoreEnvironmentService,
    private producerService: ProducerService
  ) {
    this.adminAccountUrl = this.coreEnvironmentService.getArtistAdministrationLink()
  }

  ngOnInit(): void {
    this.authService.user.subscribe(res => {
      this.user = res
    })

    this.producerService.producer.subscribe(res => {
      this.newAvatar = res && res.images.thumbnail
    })
  }

  // close account menu dropdown when click outside
  // https://stackoverflow.com/a/40107009
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isMenuOpen = false
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen
  }

  closeAccountMenu() {
    this.isMenuOpen = false
  }

  logout() {
    this.closeAccountMenu()
    this.authService.logout()
    this.router.navigate(['/'])
    this.cartService.cleanOutTracks()
  }
}
